import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './BusinessPortfolios.module.css';
import { API_BASE_URL } from '../../config';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS";
import { Plus, Image as ImageIcon } from 'lucide-react';

const BusinessPortfoliosDashboard = () => {
    const [portfolios, setPortfolios] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [username, setUsername] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodeToken = jwtDecode(token);
            setUsername(decodeToken.UserName || 'User');
        }

        const fetchPortfolios = async () => {
            setIsLoading(true);
            try {
                const loggedInBusinessId = localStorage.getItem('loggedInBusinessId');
                const businessId = loggedInBusinessId;
                if (!businessId) {
                    setError("Business ID not found. Please log in as a business user.");
                    setIsLoading(false);
                    return;
                }

                const response = await axios.get(`${API_BASE_URL}/api/WorkPortfolio/WorkPortfolios?businessId=${businessId}`);
                if (response.data && Array.isArray(response.data.model)) {
                    setPortfolios(response.data.model);
                } else {
                    setPortfolios([]);
                }
            } catch (err) {
                setError('Failed to fetch work portfolios. Please try again.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPortfolios();
    }, []);

    // --- HELPER TO FIX IMAGE URLS ---
    const getPortfolioImage = (mediaUrl) => {
        // 1. Check if media array exists
        if (!mediaUrl || mediaUrl.length === 0) {
            return 'https://via.placeholder.com/400x300?text=No+Image';
        }

        const path = mediaUrl[0].url;

        // 2. If path is null or empty
        if (!path) return 'https://via.placeholder.com/400x300?text=No+Image';

        // 3. If it's already an absolute URL (e.g. starts with http), return it
        if (path.startsWith('http') || path.startsWith('https')) {
            return path;
        }

        // 4. If it's relative, prepend the API_BASE_URL
        // Ensure we don't have double slashes
        const baseUrl = API_BASE_URL.replace(/\/$/, '');
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        
        return `${baseUrl}${cleanPath}`;
    };

    return (
        <div className={styles.pageContainer}>
            
            <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'portfolios'} />

            {/* GOLD HEADER BAR */}
            <header className={styles.header}>
                <div className={styles.headerContent}>
                    <div>
                        <h1 className={styles.headerTitle}>Portfolio Dashboard</h1>
                    </div>
                    <Link to="/business-portfolios/new" className={styles.btnGold}>
                        <Plus size={18} /> Create Work Portfolio
                    </Link>
                </div>
            </header>

            <div className={styles.mainContainer}>
                {isLoading && <p>Loading...</p>}
                {error && <p className={styles.error}>{error}</p>}

                {!isLoading && !error && portfolios.length === 0 && (
                    <div style={{textAlign:'center', padding:'4rem', color:'#64748b', border:'2px dashed #e2e8f0', borderRadius:'12px'}}>
                        <ImageIcon size={48} style={{opacity:0.2, marginBottom:'1rem'}} />
                        <p>No work portfolios found.</p>
                        <p style={{fontSize:'0.9rem'}}>Create a portfolio to showcase your best work.</p>
                    </div>
                )}

                {!isLoading && !error && portfolios && portfolios.length > 0 && (
                    <div className={styles.jobList}>
                        {portfolios.map((portfolio) => (
                            <Link to={`/business-portfolios/${portfolio.portfolioId}`} key={portfolio.portfolioId} className={styles.jobCardLink}>
                                <div className={styles.jobCard}>
                                    <div className={styles.jobCardImage}>
                                        <img 
                                            // USE THE HELPER FUNCTION HERE
                                            src={getPortfolioImage(portfolio.mediaUrl)} 
                                            alt={portfolio.title} 
                                            onError={(e) => {
                                                e.target.onerror = null; 
                                                e.target.src='https://via.placeholder.com/400x300?text=Error+Loading';
                                            }}
                                        />
                                    </div>
                                    <div className={styles.jobCardContent}>
                                        <h3>{portfolio.title}</h3>
                                        <p>{portfolio.description || "No description provided."}</p>
                                        <div className={styles.jobCardFooter}>
                                            {portfolio.suburb && portfolio.postcode ? (
                                                <span>{portfolio.suburb}, {portfolio.postcode}</span>
                                            ) : (
                                                <span>Location Not Specified</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BusinessPortfoliosDashboard;